<div class="carousel" [ngClass]="{ 'gradient-image': isFinalStep }">
  @if (!isFirstStep) {
    <div [class.active]="!isFirstStep" class="header" [@fadeInOut]>
      <c-icon-button
        [materialIcon]="'arrow_back'"
        [accessibleText]="'Hello, world!'"
        [showTextAsTooltip]="'true'"
        [size]="'large'"
        [colorTokenString]="'color-neutral-800'"
        [symbolType]="'rounded'"
        [iconFill]="false"
        (onClick)="onPrevious()"
      ></c-icon-button>
      <div class="bars">
        @for (item of [].constructor(6); track item; let i = $index) {
          <div
            class="bar"
            [ngClass]="i < currentSlide ? 'filled' : 'unfilled'"
          ></div>
        }
      </div>
      <button class="skip-introduction" (click)="onSkip()">
        {{ "INTRODUCTION.SKIP_MOBILE" | translate }}
      </button>
    </div>
  }
  @for (slide of slides; track slide; let i = $index) {
    <div class="slides-container" [@fadeInOut]>
      <div
        [class.active]="i === currentSlide"
        class="slide"
        [ngClass]="slide.step !== 'welcome' ? 'top-adjustment' : ''"
      >
        @if (slide.step !== "ready") {
          <img
            [ngClass]="isFirstStep ? 'big-image' : 'normal-image'"
            [src]="slide.imgSrc"
            [alt]="slide.alt ? slide.alt : ('' | translate)"
          />
        }
        @if (slide.step === "welcome") {
          <img
            class="cariloop-logo"
            src="assets/img/Cariloop-Logo-Black.svg"
            [alt]="'GENERAL.CARILOOP_LOGO_ALT' | translate"
          />
        }
        <div class="content" [ngClass]="{ 'space-elements': isFinalStep }">
          <div
            class="text-content"
            [ngClass]="{
              'text-gap': isFinalStep,
            }"
          >
            <h1
              class="text-content__title"
              [ngClass]="
                isFirstStep || isFinalStep
                  ? 'heading-1-mixin'
                  : 'heading-2-mixin'
              "
            >
              {{ slide.title | translate }}
            </h1>
            <p
              [innerHTML]="slide.paragraph | translate"
              class="text-content__subtitle"
            ></p>
          </div>
          @if (slide.step === "welcome" || slide.step === "ready") {
            <div class="buttons-container">
              <button (click)="onNext()" class="black-button">
                {{
                  (!isFinalStep
                    ? "INTRODUCTION.GET_STARTED_BUTTON"
                    : "INTRODUCTION.CREATE_ACCOUNT"
                  ) | translate
                }}
              </button>
              <span class="account-text"
                >{{ "INTRODUCTION.ACCOUNT" | translate }}
                <a
                  href="/login"
                  [attr.aria-label]="'INTRODUCTION.LOGIN_ARIA' | translate"
                  >{{ "INTRODUCTION.LOG_IN" | translate }}</a
                ></span
              >
            </div>
          }
          @if (!(slide.step === "welcome" || slide.step === "ready")) {
            <button class="transparent-button" (click)="onNext()">
              {{ "INTRODUCTION.NEXT_BUTTON" | translate }}
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>
